<div>
  <!-- Squelette pour l'en-tête du tableau de bord -->
  <div class="row align-items-center">
    <div class="col-12 col-md-6 col-lg-5">
      <app-skeleton-rect
        width="90%"
        [style.max-width]="'200px'"
        height="28px"
        class="mb-3 mb-md-2">
      </app-skeleton-rect>
    </div>
    <div class="col-12 col-md-6 col-lg-7">
      <div class="d-flex flex-column flex-sm-row align-items-center justify-content-md-end">
        <!-- Date/text section -->
        <div class="d-flex align-items-center mb-2 mb-sm-0 me-sm-3">
          <app-skeleton-rect
            width="160px"
            height="16px"
            class="me-2 d-inline-block">
          </app-skeleton-rect>
          <!-- Icon skeleton -->
          <app-skeleton-rect
            width="32px"
            height="32px"
            [borderRadius]="'8px'">
          </app-skeleton-rect>
        </div>

        <!-- Button group - responsive layout -->
  <div class="d-flex flex-wrap justify-content-center justify-content-sm-end pb-1 px-2">
            <app-skeleton-rect
            width="80px"
            [style.min-width]="'70px'"
            height="36px"
            [borderRadius]="'8px'"
            class="me-1 mb-1 mb-sm-0">
          </app-skeleton-rect>
          <app-skeleton-rect
            width="100px"
            [style.min-width]="'80px'"
            height="36px"
            [borderRadius]="'8px'"
            class="me-1 mb-1 mb-sm-0">
          </app-skeleton-rect>
          <app-skeleton-rect
            width="70px"
            [style.min-width]="'60px'"
            height="36px"
            [borderRadius]="'8px'"
            class="mb-1 mb-sm-0">
          </app-skeleton-rect>
        </div>
        </div>
    </div>
  </div>

  <!-- Squelette pour les 4 cartes KPI -->
  <div class="row">
    <ng-container *ngFor="let i of [0,1,2,3]">
      <div class="col-xl-3 col-lg-6 col-md-6 col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                <div class="flex-grow-1 w-100 mb-3 mb-sm-0 pe-sm-2">
                  <!-- Titre responsive -->
                  <app-skeleton-rect
                    width="100%"
                    [style.max-width]="'120px'"
                    [style.min-width]="'80px'"
                    height="14px"
                    class="mb-2">
                  </app-skeleton-rect>
                  <!-- Valeur responsive -->
                  <app-skeleton-rect
                    width="100%"
                    [style.max-width]="'150px'"
                    [style.min-width]="'100px'"
                    height="20px"
                    class="mt-2">
                  </app-skeleton-rect>
                </div>
                <!-- Icône responsive -->
                <div class="flex-shrink-0 align-self-center align-self-sm-start">
                  <app-skeleton-rect
                    width="60px"
                    [style.min-width]="'50px'"
                    height="60px"
                    [style.min-height]="'50px'"
                    [borderRadius]="'10px'"
                    class="mx-auto mx-sm-0">
                  </app-skeleton-rect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Squelette pour la section du graphique des statistiques de vente -->
  <div class="row match-height">
    <div class="col-xl-9 col-lg-12">
      <app-global-dashboard-chart-skeleton></app-global-dashboard-chart-skeleton>
    </div>

    <!-- Squelette pour la section "Top Selling Products" -->
    <div class="col-xl-3 col-lg-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <app-skeleton-rect width="160px" height="18px"></app-skeleton-rect>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-container *ngFor="let j of [0,1,2,3,4,5]">
              <div class="media pt-2 pb-2">
                <app-skeleton-rect width="35px" height="35px" [borderRadius]="'50%'" class="me-3"></app-skeleton-rect>
                <div class="media-body w-100">
                  <app-skeleton-rect width="85%" height="14px" class="mb-1"></app-skeleton-rect>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Squelette pour la grille des cartes de sites & "Last Orders" -->
  <div class="row match-height">
    <div class="col-xl-9 col-lg-12 col-12">
      <!-- Utilisation du composant squelette séparé pour les sites -->
      <app-sites-grid-skeleton *ngIf="showSitesGrid"></app-sites-grid-skeleton>
    </div>
    <div class="col-xl-3 col-lg-12 col-12">
      <div class="card flex-fill">
        <div class="card-header">
          <app-skeleton-rect width="160px" height="18px"></app-skeleton-rect>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-container *ngFor="let z of [0,1,2,3,4,5]">
              <div class="media pt-2 pb-2">
                <app-skeleton-rect width="35px" height="35px" [borderRadius]="'50%'" class="me-3"></app-skeleton-rect>
                <div class="media-body w-100">
                  <app-skeleton-rect width="70%" height="12px" class="mb-1"></app-skeleton-rect>
                  <app-skeleton-rect width="40%" height="12px"></app-skeleton-rect>
                </div>
                <div class="text-end">
                  <app-skeleton-rect width="80px" height="20px" [borderRadius]="'10px'" class="mb-1"></app-skeleton-rect>
                  <app-skeleton-rect width="100px" height="14px"></app-skeleton-rect>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


